module.exports = __webpack_public_path__ + "static/img/square-32.191f4f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/receptacles/square-32.jpg
// module id = 618
// module chunks = 0